module.exports = __webpack_public_path__ + "static/media/04.8e530525.svg";